import React, { useEffect, useState } from 'react';
import { Nav } from 'react-bootstrap';

import CentredSpinner from '../../Components/CentredSpinner';
import DataTable from '../../DataTable/datatable.component';
import SelectFilter from '../../DataTable/datatable.selectfilter';
import LineEditDialog from '../../Dialogs/Configuration/LineEditDialog';
import { Line } from '../../Types/Line';
import { useBusinessUnits } from '../../Utilities/useBusinessUnits';
import { useHttpUtils } from '../../Utilities/useHttpUtils';
import CommonConfigPage from './CommonConfigPage';

interface LinesTableProps {
    showEditDialog: any,
    includeDeleted: boolean,
    refresh: any,
}

function LinesTable({ showEditDialog, includeDeleted, refresh }: LinesTableProps) {
    const { fetchDataAuthenticated } = useHttpUtils();
    const [loaded, setLoaded] = useState(true);
    const [errored, setErrored] = useState(false);
    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        const getLines = async function () {
            let url = `api/v1/line/?includeDeleted=${includeDeleted}`;

            await fetchDataAuthenticated(url)
                .then(response => {
                    if (response.ok) {
                        return response.json();
                    }
                    throw new Error('Something went wrong.');
                })
                .then(data => {
                    setTableData(data);
                    setErrored(false);
                    setLoaded(true);
                })
                .catch(error => {
                    setErrored(true);
                    setLoaded(false);
                });
        };

        getLines();
    }, [includeDeleted, refresh, fetchDataAuthenticated]);

    const tableColumns = [
        {
            Header: 'Name',
            accessor: 'name',
            filter: 'includesString',
            Cell: (props: any) => {
                return (<Nav><Nav.Link onClick={() => { showEditDialog(props.row.original); }}>{props.value}</Nav.Link></Nav>);
            }
        },
        {
            Header: 'Production Line Identifier',
            accessor: 'productionLine',
            filter: 'includesString'
        },
        {
            Header: 'Release Sample Point',
            accessor: 'releaseSamplePoint',
            filter: 'includesString'
        },
        {
            Header: 'Auto Review',
            accessor: (d: Line) => d.allowAutoReview === true ? "Yes" : "No",
            id: 'allowAutoReview',
            Filter: SelectFilter,
            options: ["Yes", "No"]
        },
        {
            Header: 'Auto Grade',
            accessor: (d: Line) => d.allowAutoGrade === true ? "Yes" : "No",
            id: 'allowAutoGrade',
            Filter: SelectFilter,
            options: ["Yes", "No"]
        },
        {
            Header: 'Business Unit',
            accessor: 'businessUnitName',
            Filter: SelectFilter,
            filter: 'equals'
        }
    ];

    const getRowProps = (row: any) => {
        if (row.original.isDeleted)
            return { className: "deleted" };

        return {};
    };

    return (loaded
        ? <DataTable tableColumns={tableColumns} tableData={tableData} getRowProps={getRowProps} autoResetPage={false} />
        : errored
            ? <p>There was a problem.</p>
            : <CentredSpinner />
    );
}

function LineConfiguration() {

    const { businessUnits } = useBusinessUnits(false);

    const getNewLine = () => {
        return { lineId: null, name: "", businessUnitId: null, isDeleted: false };
    };

    return (
        <CommonConfigPage
            title="Lines"
            Table={LinesTable}
            Dialog={LineEditDialog}
            getNewConfigObject={getNewLine}
            businessUnits={businessUnits}
        />
    );
}

export default LineConfiguration;